import Dashboard from "./pages/dashboard/Dashboard";
import BusinessSearchPage from "./pages/businessSearch/BusinessSearchPage";
import SettingsPage from "./pages/settings/SettingsPage";
import BusinessDetailsPage from "./pages/details/BusinessDetailsPage";
import UserSearchPage from "./pages/usersManagement/UserSearchPage";
import GroupedUserAccount from "./pages/usersManagement/groupedUserAccounts";
import UserDetailsPage from "./pages/usersManagement/userDetails/UserDetailsPage";
import GenerateUserQrcodesPage from "./pages/generateUserQrcodesAdd/GenerateUserQrcodesPage";
import TechPage from "./pages/tech/TechPage";

// Define a type for the route object
type Route = {
  path: string;
  element: any;
};

// Define the route configuration
const route: Route[] = [
  {
    path: "/",
    element: <Dashboard />
  },
  {
    path: "/dashboard",
    element: <Dashboard />
  },
  {
    path: "/business-search",
    element: <BusinessSearchPage />
  },
  {
    path: "/settings/:businessId/:merchantId",
    element: <SettingsPage />
  },
  {
    path: "/business-details/:businessId",
    element: <BusinessDetailsPage />
  },
  {
    path: "/users",
    element: <UserSearchPage />
  },
  {
    path: "/user/:userId",
    element: <UserDetailsPage />
  },
  {
    path: "grouped-account/:id",
    element: <GroupedUserAccount />
  },
  {
    path: "/generate-user-qrcodes",
    element: <GenerateUserQrcodesPage />
  },
  {
    path: "/tech-tools",
    element: <TechPage />
  }
];

export default route;
